<template>
  <div>
    <h2 class="text-xl font-bold pt-8 uppercase">{{ label }}</h2>
    <ol v-if="overrides.length" class="mt-1 space-y-2">
      <li v-for="(override, i) in overrides">
        <SuggestionItem
          :override="override"
          :show-mirus-controls="hasDetailEditPermission"
        />
      </li>
    </ol>
    <div
      v-else
      class="border-2 border-gray-200 rounded-xl px-3 py-2 text-center text-gray-500"
    >
      {{ emptyMessage }}
    </div>
  </div>
</template>
<script setup>
import { formatRelative, parseISO } from "date-fns";
import { storeToRefs } from "pinia";
import { computed, onMounted, ref } from "vue";
import SuggestionItem from "@/components/editor/SuggestionItem.vue";
import CircleExclamation from "@/components/icons/CircleExclamation.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import useUserStore from "@/stores/user";

const userStore = useUserStore();
const { user } = storeToRefs(userStore);

const props = defineProps({
  overrides: {
    type: Object,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  emptyMessage: {
    type: String,
    default: "There are no pending suggestions",
  },
});

const hasDetailEditPermission = computed(() => {
  return user.value?.permissions?.includes("can_edit_dco_additional_feedback");
});
</script>
